import * as React from "react";
import { forwardRef } from "react";
const SvgUserCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-circle-user-round-icon lucide-circle-user-round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 20a6 6 0 0 0-12 0" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 10, r: 4 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10 }));
const ForwardRef = forwardRef(SvgUserCircle);
export default ForwardRef;
